<template>
  <div class="bg">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-spacer />
              <v-card class="elevation-12">
                <v-toolbar-title>
                  <v-img class="logo mt-2" src="logo-color.png" />
                </v-toolbar-title>
                <v-card-text>
                  <v-text-field
                    v-model="email"
                    v-validate="'required'"
                    prepend-icon="person"
                    name="email"
                    :label="`${$t('fields.users.username')} / ${$t(
                      'fields.users.email'
                    )}`"
                    :data-vv-name="`${$t('fields.users.username')} / ${$t(
                      'fields.users.email'
                    )}`"
                    :error-messages="
                      errors.collect(
                        `${$t('fields.users.username')} / ${$t(
                          'fields.users.email'
                        )}`
                      )
                    "
                  />
                  <v-text-field
                    v-model="password"
                    v-validate="'required|min:6'"
                    prepend-icon="lock"
                    name="password"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    :label="$t('fields.users.password')"
                    :data-vv-name="$t('fields.users.password')"
                    :error-messages="
                      errors.collect($t('fields.users.password'))
                    "
                    @keyup.enter="submit"
                    @click:append="showPassword = !showPassword"
                  />
                </v-card-text>
                <v-card-actions>
                  <router-link :to="{ name: 'lostPassword' }" class="link">
                    {{ $t('action.messages.forgotPassword') }}
                  </router-link>
                  <v-spacer />
                  <v-btn
                    small
                    color="primary"
                    :loading="loading"
                    @click="submit"
                  >
                    {{ $t('action.buttons.login') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer class="pa-3 footer-bg">
        <span class="caption"
          >Glospen SL &copy; {{ new Date().getFullYear() }}</span
        >
        <v-spacer />
        <terms login />
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Terms from '@/components/widgets/Terms'
export default {
  components: { Terms },
  data: () => ({
    email: '',
    password: '',
    register: 'backoffice',
    showPassword: false,
  }),
  computed: mapState({
    loading: (state) => state.auth.loading,
  }),

  methods: {
    ...mapActions({
      login: 'auth/login',
    }),
    submit() {
      this.validate().then((valid) => {
        if (!valid) return
        const { email, password, register } = this
        this.login({
          email,
          password,
          register,
        })
      })
    },
  },
}
</script>

<style>
.logo {
  margin: auto;
  max-width: 250px;
}
.bg {
  background-image: url('/background.png');
  background-size: cover;
  background-color: #00482b;
}
#inspire {
  background: none;
}
.footer-bg {
  color: white !important;
  background-color: transparent !important;
}
</style>
